import React from 'react';
import logoLight from '@assets/img/light-logo.svg';

const LogoLight = () => (
  <img src={logoLight} style={{ width: '14rem' }} alt="Logo Light" />
);

export default LogoLight;
